import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Message from '../../routes/conversations/components/Message';
import GeckoLocation from '../../services/gecko-location';
import { updateSearchSelected } from '../../actions/search.jsx';
import { CONSTS } from 'constants/index.js';

class AppSearchResult extends Component {
  jumpToConversation(message) {
    this.props.updateSelected(true);
    const filter = {
      filter: CONSTS.FILTER_CONTACT,
      contact: message.Conversation.user_id,
    };
    const queryString = Object.assign({}, GeckoLocation.params, filter, {
      message: message.id,
    });
    const path = `/conversations/${message.conversation_id}`;
    // Due to the way componentWillReceiveProps has been set up on the ChatHeadContainer we need to first change the path and then change the params
    GeckoLocation.goTo(path, GeckoLocation.params).then(() => {
      GeckoLocation.goTo(path, queryString);
    });
  }

  jumpToUser(user) {
    if (user.type === 'agent') {
      GeckoLocation.goTo(`/agents/${user.id}`);
    } else {
      this.jumpToConversation(this.props.message);
    }
  }

  render() {
    if (
      !this.props.message ||
      !this.props.message.Conversation ||
      !this.props.message.Conversation.User
    ) {
      return null;
    } // Catch old data that could cause UI bugs
    let title = this.props.message.Conversation.User.full_name;
    if (!this.props.message.Conversation.Agents.length) {
      title = `${title}(unassigned)`;
    } else if (this.props.message.Conversation.Agents.length === 1) {
      title = `${title} with ${this.props.message.Conversation.Agents[0].full_name}`;
    } else {
      title = `${title} with ${
        this.props.message.Conversation.Agents[0].full_name
      } (${this.props.message.Conversation.Agents.length - 1} other)`;
    }
    return (
      <div className="AppSearchResult">
        <span className="AppSearchResult-ContactName">{title}</span>
        <Message
          key={this.props.message.id}
          message={this.props.message}
          onMessageClick={() => this.jumpToConversation(this.props.message)}
          onAvatarClick={() => this.jumpToUser(this.props.message.Sender)}
        />
      </div>
    );
  }
}

AppSearchResult.propTypes = {
  message: PropTypes.object,
};

const mapStateToProps = (store) => {
  return {
    conversations: store.conversations,
    contacts: store.contacts,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateSelected: (isSelected) => {
      dispatch(updateSearchSelected(isSelected));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AppSearchResult);
